"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 animate-pulse rounded bg-slate-800" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-slate-400 transition-colors hover:text-white">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function NetworkFooter() {
  const currentYear = new Date().getFullYear();
  const platformLinks = [{
    label: "Pricing",
    href: "/PricingPage"
  }, {
    label: "White-Label for Agencies",
    href: "/WhiteLabelForAgenciesPage"
  }, {
    label: "Capacity Packs",
    href: "/CapacityPacksPage"
  }, {
    label: "Security & Governance",
    href: "/SecurityAndGovernancePage"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }, {
    label: "Cookie Policy",
    href: "#"
  }];
  return <footer data-section-id="135437" id="strategic-footer" className="bg-[#0f172a] px-6 pt-16 pb-8 font-sans text-slate-100 md:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 mb-14 md:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588799/img/elorag_logo.png" alt="EloRAG" className="h-8 w-auto brightness-0 invert" />
            </Link>

            <p className="max-w-sm text-sm leading-relaxed text-slate-400">
              EloRAG is a governance-first, multi-tenant AI platform for organizations and agencies
              that need approved-only content access, citation-based answers, tenant isolation, and
              predictable scaling.
            </p>
          </div>

          <div>
            <h3 className="mb-6 text-base font-semibold tracking-tight text-white">Navigation</h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="mb-6 text-base font-semibold tracking-tight text-white">Platform</h3>
            <ul className="space-y-3">
              {platformLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-sm text-slate-400 transition-colors hover:text-white">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="mb-6 text-base font-semibold tracking-tight text-white">Get Started</h3>

            <div className="space-y-4">
              <p className="text-sm leading-relaxed text-slate-400">
                Talk with EloRAG about subscriptions, white-label, capacity planning, or enterprise deployment.
              </p>

              <div className="flex flex-col gap-3">
                <Button asChild className="h-11 justify-center bg-primary text-primary-foreground hover:bg-primary/90">
                  <Link to="/BookADemoContactSalesPage">
                    Book a Demo
                    <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>

                <Button asChild variant="outline" className="h-11 justify-center border-slate-700 bg-transparent text-white hover:bg-slate-800 hover:text-white">
                  <Link to="/PricingPage">View Pricing</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>

        <Separator className="mb-8 bg-slate-800" />

        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-sm text-slate-400">
            &copy; {currentYear} EloRAG. All rights reserved.
          </p>

          <ul className="flex flex-wrap gap-6">
            {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                <Link to={link.href} className="text-sm text-slate-400 transition-colors hover:text-white">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}